import { LogLevel } from 'ia-react-core/~/interfaces/LogLevel';
import getCurrentLogLevels from './_getCurrentLogLevels';
import { LoggerReporter } from './createLogger';

const log = (namespace: string, level: LogLevel, reporters: LoggerReporter[], ...args: unknown[]) => {
  const currentLogLevels = getCurrentLogLevels(namespace);

  if (currentLogLevels.includes(level)) {
    reporters.forEach((reporter) => reporter(namespace, level, ...args));
  }
};

export default log;
